// extracted by mini-css-extract-plugin
export default {"mainContainer":"adminMenu_mainContainer__KuKXn","ul":"adminMenu_ul__TKRag","visitSite":"adminMenu_visitSite__EzYWK"};